import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const TotalList = (props) => {
  let amountRefunded = 0;
  if (props?.data?.transactions?.length > 0) {
    props.data.transactions?.forEach((transaction) => {
      let amountRefund = transaction?.status === 'refund' ? transaction.amount : 0;
      amountRefunded += amountRefund;
    });
  }

  let cashBalanceCharged = 0;
  let subtotal = 0;
  let tax = 0;
  let redeemedTokenValue = 0;
  let discountApplied = 0;
  let surchargeAmount = 0;
  let promoDiscount = props?.data?.total_promo_discount || 0;
  let tokens_redeemed = { ...props?.data?.tokens_redeemed || {} };

  props.data.items.forEach((item, index) => {
    if (index === 0) {
      cashBalanceCharged += item?.cashBalanceCharged || 0;
      cashBalanceCharged += item?.promoBalanceCharged || 0;
    }
    if (!isNaN(item?.item_tax)) {
      if (item.redeemed_token_id) {
        redeemedTokenValue += item.price;
        tokens_redeemed[item.redeemable_token_id] = {
          ...tokens_redeemed[item.redeemable_token_id],
          redeemable_token_name: item.redeemable_token_name
        };
      }
      if (item.hasOwnProperty("item_discount_applied")) {
        discountApplied += item.item_discount_applied;
      }
      tax = props.data.tax;
    } else {
      tax = props.data.tax;
    }
    if (item.hasOwnProperty("surchargeAmount")) {
      surchargeAmount = item.surchargeAmount || 0;
    } else {
      surchargeAmount = props.data.digital_surcharge || 0;
    }
    subtotal = props.data.subtotal;
  });

  let total = (subtotal - redeemedTokenValue - discountApplied - promoDiscount - amountRefunded) +
      (tax + props.data.tip + surchargeAmount) -
      cashBalanceCharged;

  return (
      <Accordion defaultExpanded={props.defaultExpand !== false}>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
        >
          <Typography variant="h6" gutterBottom>
            Total Summary
          </Typography>
        </AccordionSummary>
        <Paper sx={{ width: '100%', overflowX: 'auto' }}>
          <Table>
            <TableHead />
            <TableBody>
              <TableRow>
                <TableCell>Subtotal</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>
                  {`$ ${(subtotal / 100).toFixed(2)}`}
                </TableCell>
              </TableRow>
              {redeemedTokenValue > 0 && (
                  <TableRow>
                    <TableCell>Redeemed Token Value</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>
                      {`$ ${(redeemedTokenValue / 100).toFixed(2)}`}
                    </TableCell>
                  </TableRow>
              )}
              {discountApplied > 0 && (
                  <TableRow>
                    <TableCell>Discount</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>
                      {`-$ ${(discountApplied / 100).toFixed(2)}`}
                    </TableCell>
                  </TableRow>
              )}
              {promoDiscount > 0 && (
                  <TableRow>
                    <TableCell>Promo Discount</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>
                      {`-$ ${(promoDiscount / 100).toFixed(2)}`}
                    </TableCell>
                  </TableRow>
              )}
              <TableRow>
                <TableCell>{props.data.event?.digital_surcharge_label}</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>
                  {`$ ${(props.data.digital_surcharge / 100).toFixed(2)}`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Tip</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>
                  {`$ ${(props.data.tip / 100).toFixed(2)}`}
                </TableCell>
              </TableRow>
              {cashBalanceCharged > 0 && (
                  <TableRow>
                    <TableCell>Cash Balance Charged</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>
                      {`$ ${(cashBalanceCharged / 100).toFixed(2)}`}
                    </TableCell>
                  </TableRow>
              )}
              <TableRow>
                <TableCell>Tax</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>
                  {`$ ${(tax / 100).toFixed(2)}`}
                </TableCell>
              </TableRow>
              {amountRefunded !== 0 && (
                  <TableRow>
                    <TableCell>Refund</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>
                      {`$ ${(amountRefunded / 100).toFixed(2)}`}
                    </TableCell>
                  </TableRow>
              )}
              <TableRow>
                <TableCell>
                  <strong>Total</strong>
                </TableCell>
                <TableCell sx={{ textAlign: 'right' }}>
                  <strong>{`$ ${(total / 100).toFixed(2)}`}</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </Accordion>
  );
};
